import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className"];
import React from 'react';
import classes from '@nerdwallet/base-styles/classes';
import { useDeprecatedClassNameStylePropsWarning } from '../../internal/deprecated-classname-style-props';
import { Box } from '../Box/Box';

/**
 * A max-width container that's centered on the page
 * with horizontal margins. Used to implement Figma layouts
 * that were designed within the Currency grid system.
 */
export var CenteredContainer = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  useDeprecatedClassNameStylePropsWarning('CenteredContainer', {
    className: className
  });
  return /*#__PURE__*/React.createElement(Box, _extends({}, otherProps, {
    marginX: "auto",
    paddingX: {
      mobile: 3,
      desktop: 5
    },
    className: [classes('max-width-container'), className],
    ref: ref
  }), children);
});
CenteredContainer.displayName = 'CenteredContainer';